import { fromJS } from 'immutable';

import {
  UPDATE_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS_SUCCESS,
  UPDATE_NOTIFICATION_SETTINGS_FAILURE,
} from '../actions/actionTypes';
import { NOTIFICATION_TYPES } from '../../components/NotificationSettingsContainer';

const initialState = fromJS({
  notification: {
    [NOTIFICATION_TYPES.EMAIL]: {
      isUpdating: false,
    },
    [NOTIFICATION_TYPES.SMS]: {
      isUpdating: false,
    },
  },
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_NOTIFICATION_SETTINGS:
      return state.setIn(
        ['notification', action.notificationType, 'isUpdating'],
        true,
      );
    case UPDATE_NOTIFICATION_SETTINGS_SUCCESS:
    case UPDATE_NOTIFICATION_SETTINGS_FAILURE:
      return state.setIn(
        ['notification', action.notificationType, 'isUpdating'],
        false,
      );
    default:
      return state;
  }
};

export default reducer;
